import React from 'react';
import { useParams } from 'react-router-dom';

import { useHomeData } from '../components/LoadHomeData/HomeDataProvider';
import { NoAccessToView } from '../components/NoAccessToView/NoAccessToView';
import { TemporaryBadgeScanResult } from '../components/TemporaryBadgeScanResult/TemporaryBadgeScanResult';
import { useTranslations } from '../components/Translations/TranslationsProvider';

export const TemporaryBadgeScanResultPage = () => {
    const { nonce } = useParams();
    const { translations } = useTranslations();
    const { homepageData } = useHomeData();
    const isGuard = homepageData?.authorizations?.mayUseGuardsMobileFx ?? false;

    return (
        <>
            {!isGuard && <NoAccessToView translations={translations} />}
            {isGuard && <TemporaryBadgeScanResult nonce={nonce} translations={translations} />}
        </>
    );
};
